<template>
    <div style="background:white" class="ve-list-page">
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:40px;  border-bottom:2px solid #389">
            <div style="min-width:1100px;display:flex;padding-top:3px">   
                <span style="color:#606266;margin-left:6px;margin-right:4px;font-size:12px"> {{ $LANG('1324', '起始对账日期') }} </span>
                <el-date-picker  type="date" size="small"  v-model="frdttm" clearable value-format="yyyy-MM-dd" style="width:140px;" ></el-date-picker>  
                <span style="color:#606266;margin-left:6px;margin-right:4px;font-size:12px"> {{ $LANG('1301', '结束对账日期') }} </span>
                <el-date-picker  type="date" size="small"  v-model="todttm" clearable value-format="yyyy-MM-dd" style="width:140px;" ></el-date-picker>  
                <span style="color:#606266;margin-left:6px;margin-right:4px;font-size:12px"> {{ $LANG('1013', '银行账户') }} </span>
                <el-select v-model="bankact"  size="small" style="width:160px;" clearable >
                    <span v-for="item in bankArr" :key='item.key'>
                        <el-option :label="item.ACCNM" :value="item.IDSEQ"  ></el-option>
                    </span>
                </el-select>
 
                <el-button @click="qryTabData" type="primary" size="mini" icon="iconfont icon-gaojichazhao2" style="height:32px;margin-left:15px">{{ $LANG('0140', '查询') }}</el-button>
                <el-checkbox @change="showEvent" true-label="Y"  false-label="N" v-model="showStop" style="margin-left:15px;">{{ $LANG('0725', '不显示已勾对记录') }}</el-checkbox>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div> 
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
                :table-data="tabData"
                :columnHiddenOption="columnHiddenOption"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                :scroll-width="0"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :max-height="tabHeight"
                :virtual-scroll-option="virtualScrollOption"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                :column-width-resize-option="columnWidthResizeOption"
                :cellSelectionOption="{enable: false}"
                v-loading="loading"
                :element-loading-text="$LANG('1959', '加载中')"
                ref="tabref">
        </ve-table>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <div style="padding-left:5px;overflow: hidden;display:flex;line-height:30px;height:34px;margin-top:5px;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="color:#606266; font-size:12px;width:35px;margin-left:10px ;">{{ $LANG('0349', '每页') }}</div>
            <el-select v-model="rowSize" size="small" style="width:80px;margin-right:10px ;" @change="initPage">
                <el-option v-for="item in pageList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
            <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input>
            <span style="color:#606266;margin-left:10px ;font-size:12px;">{{ $LANG('1660', '页') }}</span>
            <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button>
        </div> 
        <!-- 提示框 -->
        <el-dialog  :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
 
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate, getDate2} from '../../api/Select' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'
//局部注册
export default {
    name:"inv_bankchk",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '15334',
            fieldIdseq: '15334',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    components: { VeColumnConfigDialog },
    data () {
        return {
            current:1,
            pageList: [ {
                value: 100,
                label: '100'
                }, {
                value: 200,
                label: '200'
            }],
            dataCount:0,
            rowSize:100,
            goPage:'',
            loading:false,
            comFlag:false,
            showStop:'Y',
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            frdttm:'',
            stfgColor:'',
            todttm:'',
            bankArr: [],
            selparam:'',
            disabled:false, //新增权限制
            txtparam:'',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            bankact:'',
            tabData:[], //表数据
 
            tabArr:[], //表列
            initCol:[],
            vueCol:[],
            columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: { headerCellClass: () => 'table-head-cell-class', bodyCellClass: () => 'table-body-cell-class1' },
            v_headerRow:{},
            queryRequestId:0,
            virtualScrollOption: { enable: false },
 
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            allData:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
        }
    },
    mounted () { 
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','15334','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //银行账户选择
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'accty','14410','v_ac_account',' and stfg=\'Y\'').then(res=>{
            this.bankArr =res.result
        })
        this.frdttm=getDate2(60)
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 300) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 163) + 'px';
        }, 
    },
 
    created () {       
        if (this.v_username){ 
            //查询数据
            this.qryTabData()
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        showEvent(val){
            this.qryTabData()
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt=this.$LANG('1721', '请输入跳至页数')
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
    
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        //查询
        qryTabData(){
            let cond_=buildVeTableHeaderCondition(this.initCol, this.v_headerRow)
            if (this.frdttm){ //起始日期
               cond_=cond_+' and dttm >=\''+this.frdttm+'\'' 
            }
            if (this.todttm){ //结束日期
               cond_=cond_+' and dttm <=\''+this.todttm+'\'' 
            }
            if (this.bankact){
               cond_=cond_+' and cashno =\''+this.bankact+'\'' 
            }
            if (this.showStop==='Y'){
                cond_=cond_+' and ischk=\'N\''
            }
            this.current = 1
            this.getAccList( cond_ )
        },
        rowShow(){ this.v_headerRow={}; this.qryTabData() },
        //状态审核
        chkRec(row, val){
            var vm=this,cond_=''
            if (val==='Y'){
                cond_=' set ischk=\'Y\' ,chkdttm=\''+getDate('full')+'\' ,chkuser=\''+this.v_username+'\''
            }else{
                cond_=' set ischk=\'N\' , chkdttm=null  , chkuser=null'
            }
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'FIN_BANK',p_cond: cond_},
            }).then(res=>{      
                if(res.code =='200')  {           
                    this.qryTabData()     
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }        
            }) 
 
        },
        //账户明细
        getAccList(cond){
            const requestId = ++this.queryRequestId
            //获取所有产品记录且初始化分页记录    
      
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by dttm desc',p_table:'V_fin_bank'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => {
                    const table = this.$refs.tabref
                    if (table && typeof table.doLayout === 'function') table.doLayout()
                })
            }).catch((error) => { if (requestId === this.queryRequestId) { this.promptWin=true; this.prompt=error.message || this.$LANG('1641', '查询失败') } })
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15334','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabArr = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        vm.tabArr.push({
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            edcss: item.EDCSS,
                            fhide: item.FHIDE,
                            disabled: item.DISABLED,
                        })
                        if (item.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            align: item.align,
                            width: Number(item.width) || 120,
                            sortable: item.key !== 'RN' && item.EDCSS !== 'checkbox',
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader title={column.title} edcss={item.EDCSS} value={this.v_headerRow[item.key]} operator={this.v_headerRow[`#OPER${item.key}`]} on-input={(value) => this.$set(this.v_headerRow, item.key, value)} on-operator-change={(value) => this.$set(this.v_headerRow, `#OPER${item.key}`, value)} on-query={this.qryTabData} />,
                            renderBodyCell: ({row}) => item.EDCSS === 'checkbox'
                                ? <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                : row[item.key],
                        })
                    })
                    vm.vueCol.unshift({ field:'index', key:'rownum', title:vm.$LANG('0310', '序号'), width:55, align:'center', fixed:'left', disableResizing:true, renderBodyCell:({rowIndex}) => rowIndex + 1, renderHeaderCell:({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div> })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 200,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row}) => (
                            <div>
                                <i class="iconfont icon-chenggong1" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                                <el-link disabled={vm.addBool} on-click={() => vm.chkRec(row, 'Y')} underline={false}><span style="font-size:12px;margin-right:10px;">{vm.$LANG('0271', '勾对')}</span></el-link>
                                <i class="iconfont icon-chenggong1" style="font-size:14px;margin-right:5px;margin-left:8px;"></i>
                                <el-link disabled={vm.addBool} on-click={() => vm.chkRec(row, 'N')} underline={false}><span style="font-size:12px;margin-right:10px;">{vm.$LANG('0163', '取消勾对')}</span></el-link>
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                })
            })
 
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
